

exports.__esModule = true;
exports.$LandingRoute = undefined;

var _angular = require('angular');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/user/index');

var _index2 = require('xo-models/src/checkout/index');

var _index3 = require('xo-models/src/inventory/index');

var $LandingRoute = exports.$LandingRoute = _squid.$ComponentRoute.extend('LandingRoute', {
    name: 'landing',

    titleContent: 'accountCreationGuest.heading',

    scope: {
        isUnbranded: '='
    },

    trackingData: {
        fptiState: 'landing',
        trackStateExit: true
    },

    resolve: {
        action: function action($util) {
            // eslint-disable-line no-shadow

            var models = {};
            return (0, _squid.$populate)(models, {
                checkoutCart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token),
                checkoutPayeeModel: _index2.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutInputData: _index.$CheckoutInputDataModel.instance(_angular.$rootScope.token)
            }).then(function () {
                // C2 ramp - force CN country code to C2 upon landing
                if (_squid.$locale.country === 'CN') {
                    _squid.$locale.change('C2', _squid.$locale.lang);
                    _logger.$logger.info('CN_locale_forced_to_C2');
                }
            }).then(function () {
                var landingFlow = function landingFlow() {
                    var merchantCountry = models.checkoutAppData.get('merchant.merchant_country');
                    var merchantId = models.checkoutPayeeModel.getId();
                    var paymentMethodViaUrl = $util.param('paymentMethod');
                    var paymentMethodViaCheckoutAppData = models.checkoutAppData.get('user_selected_funding_source_type') === 'PAY_UPON_INVOICE' ? 'invoice' : undefined;
                    var paymentMethod = paymentMethodViaCheckoutAppData || paymentMethodViaUrl;
                    var isUnbranded = paymentMethod !== undefined;

                    function callEPM() {
                        var fundingSource = void 0;

                        if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage()) {
                            var passedInExp = $util.param('showExp');
                            fundingSource = $util.param('fundingSource');
                            if ('guest'.indexOf(passedInExp) > -1) {
                                return 'checkout.guest';
                            }

                            if ('signup'.indexOf(passedInExp) > -1) {
                                return 'checkout.signup';
                            }
                        }
                        return _index2.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                            params: {
                                'localeCountry': _squid.$locale.country,
                                'fundingSource': window.xprops && window.xprops.fundingSource || fundingSource,
                                'merchantId': merchantId,
                                'merchantCountry': merchantCountry
                            }
                        }).then(function (flowEligibility) {
                            var mode = flowEligibility.guest ? 'guest' : 'signup';

                            _logger.$logger.info(mode + '_flow_offered_by_epm_at_route');

                            var appRoute = mode === 'signup' ? 'checkout.signup' : 'checkout.guest';

                            return getProcessedRoute(appRoute);
                        });
                    }

                    /*
                     * This function is called on final route returned by this router file
                     * Description:
                     * Currently the scope of this function is limited to logging
                     * In future we can extend this scope and update the docs
                     */
                    function getProcessedRoute(appRoute) {
                        var isForcedSignup = void 0;

                        switch (appRoute) {
                            case 'checkout.guest':
                                isForcedSignup = 0;
                                break;
                            case 'checkout.signup':
                            case 'checkout.multistepsignup':
                                isForcedSignup = 1;
                                break;
                            default:
                                isForcedSignup = -1;
                                break;
                        }

                        _logger.$logger.info('checkout_fpti', {
                            from: 'LANDING_PAGE_PARAM',
                            forced_signup_offered: isForcedSignup,
                            landing_page: 'Billing',
                            locale: _squid.$locale.lang + '_' + _squid.$locale.country
                        });

                        return appRoute;
                    }

                    if (isUnbranded) {
                        var isUnbrandedAllowed = (0, _squid.$feature)('unbranded', true, merchantCountry);
                        var isPuiAllowed = (0, _squid.$feature)('invoicePayment', true, merchantCountry);

                        if (isUnbrandedAllowed && isPuiAllowed && paymentMethod === 'invoice') {
                            return getProcessedRoute('checkout.pay-upon-invoice');
                        }
                        return getProcessedRoute('checkout.guest');
                    } else if (models.checkoutAppData.get('flags.payment_experience_initiator') === 'PAYPAL_PLUS' && $util.param('exp') === 'signup') {
                        return getProcessedRoute('checkout.signup');
                    } else if ((0, _squid.$feature)('multiStepSignup', false, _squid.$locale.country)) {
                        return getProcessedRoute('checkout.multistepsignup');
                    } else if (models.checkoutInputData.isEbayTxn()) {
                        // force signup for eBay users
                        _logger.$logger.info('ebay_flow_signup');
                        return getProcessedRoute('checkout.signup');
                    } else {
                        // if you here means, now we need to determine the route based on symphony EPM call.
                        return callEPM();
                    }
                };

                var cartHasInventory = models.checkoutCart.get('cartHasInventory');
                if (_squid.$config.enableInventoryWPS && cartHasInventory) {
                    var inventoryModel = _index3.$InventoryModel.instance(_angular.$rootScope.token);
                    var inventoryInput = {
                        items: models.checkoutCart.get('purchase.items'),
                        merchantId: models.checkoutPayeeModel.getId()
                    };
                    return inventoryModel.action('getInventory', {
                        data: inventoryInput,
                        success: function success(inventoryResponse) {
                            if (inventoryResponse.showSoldoutPage) {
                                return {
                                    to: 'checkout.soldout',
                                    params: {
                                        items: encodeURIComponent(inventoryResponse.soldoutItems),
                                        soldOutUrl: encodeURIComponent(inventoryResponse.soldoutUrl)
                                    }
                                };
                            } else {
                                inventoryModel.setInvetoryItems(inventoryResponse);
                                return landingFlow();
                            }
                        }
                    });
                } else {
                    return landingFlow();
                }
            });
        }
    }
});

angular.value("$LandingRoute", $LandingRoute);
_angular.$rootScope;

_squid.$ComponentRoute;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$populate;

_logger.$logger;

_index.$CheckoutInputDataModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutCartModel;

_index2.$FlowEligibilityModel;

_index3.$InventoryModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-landing/route.js
// module id = ./pages/xo-landing/route.js
// module chunks = 1